import { render, staticRenderFns } from "./InboxName.vue?vue&type=template&id=3dc43fac&"
import script from "./InboxName.vue?vue&type=script&lang=js&"
export * from "./InboxName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports